var _defs, _clipPath, _defs2, _clipPath2, _defs3, _clipPath3, _defs4, _clipPath4, _defs5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511 831",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "st1",
    transform: "matrix(1, 0, 0, 1, -720.466675, 0.714788)",
    style: {
      opacity: 0.6
    }
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M720.6 306.4h508.7v266H720.6z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.6 306.4h508.7v266H720.6z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M975 306.4L720.6 422.1 975 572.4l254.3-150.3z",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "rgb(1, 1, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3",
    transform: "matrix(1, 0, 0, 1, -720.466675, 0.714788)",
    style: {
      opacity: 0.45
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M720.6 0H975v572.4H720.6z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.6 0H975v572.4H720.6z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M720.6 422.1L975 572.4V0z",
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "rgb(1, 1, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5",
    transform: "matrix(1, 0, 0, 1, -720.466675, 0.714788)",
    style: {
      opacity: 0.8
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M975 0h254.4v572.4H975z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975 0h254.4v572.4H975z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M975 0v572.4l254.3-150.3z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "rgb(1, 1, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3",
    transform: "matrix(1, 0, 0, 1, -720.466675, 0.714788)",
    style: {
      opacity: 0.45
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M720.6 470.3H975v358.4H720.6z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.6 470.3H975v358.4H720.6z",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M720.6 470.3L975 828.7V620.6z",
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "rgb(1, 1, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5",
    transform: "matrix(1, 0, 0, 1, -720.466675, 0.714788)",
    style: {
      opacity: 0.8
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M975 470.3h254.5v358.4H975z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M975 620.6v208.1l254.5-358.4z",
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "rgb(1, 1, 1)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.19e2eaa1.svg";
export { ForwardRef as ReactComponent };